import Axios, { Response } from '../utils/Axios';
import AsyncLocalStorage from '../utils/AsyncLocalStorage';

export type CheckoutHistoryType = {
  representLogId: number;
  noticeType: number;
  content: string;
  noticeExpectedAt: string;
  noticeCheckedCount: number;
  noticeTotalCount: number;
  sentAt: string;
  noticeTypeStr: string;
};

export type CheckoutHistoryDetailType = {
  noticeType: number;
  content: string;
  sentDate: string;
  checkoutTime: string | null;
  noticeBeforeMin: number;
  noticeTypeStr: string;
  notCheckedNoticeAreaCount: number;
  noticeCheckedDataByAreaName: AreaNoticeType[];
};

export type AreaNoticeType = {
  areaName: string;
  noticeCheckedData: AreaNoticeCheckedType[];
};

export type AreaNoticeCheckedType = {
  name: string;
  noticeChecked: boolean;
};

const CheckoutController = {
  // 퇴실알림 목록
  getHotelNoticeHistory: async (oParams: any): Promise<Response> => {
    try {
      let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_URL + '/checkout/getHotelNoticeHistory';
      const response: any = await Axios.post(sUrl, oParams);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[getHotelNoticeHistory 오류]' + oErr.toString(),
        data: undefined,
        status: 500,
      };
    }
  },
  // 퇴실알림 자세히
  getHotelNoticeHistoryDetail: async (oParams: any): Promise<Response> => {
    try {
      let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_URL + '/checkout/getHotelNoticeHistoryDetail';
      const response: any = await Axios.post(sUrl, oParams);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[getHotelNoticeHistoryDetail 오류]' + oErr.toString(),
        data: undefined,
        status: 500,
      };
    }
  },
  // 퇴실알림 매장 불러오기
  getCheckoutRepresentStoreNameAndImage: async (oParams: any): Promise<Response> => {
    try {
      let sUrl =
        process.env.REACT_APP_API_KNOCKKNOCK_URL +
        '/checkout/getCheckoutRepresentStoreNameAndImage';
      const response: any = await Axios.post(sUrl, oParams);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[getCheckoutRepresentStoreNameAndImage 오류]' + oErr.toString(),
        data: undefined,
        status: 500,
      };
    }
  },
  // 퇴실알림 매장 설정
  setCheckoutRepresentStoreNameAndImage: async (oParams: any): Promise<Response> => {
    try {
      let sUrl =
        process.env.REACT_APP_API_KNOCKKNOCK_URL +
        '/checkout/setCheckoutRepresentStoreNameAndImage';
      const response: any = await Axios.post(sUrl, oParams);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[setCheckoutRepresentStoreNameAndImage 오류]' + oErr.toString(),
        data: undefined,
        status: 500,
      };
    }
  },
};

export default CheckoutController;
